var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdmittedPatientsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.1667 20.8332L37.5 23.1832L26.6167 34.1665L20.8333 28.3332L23.1667 25.9832L26.6167 29.4498L35.1667 20.8332ZM16.6667 28.3332L21.6667 33.3332H5V29.9998C5 26.3165 10.9667 23.3332 18.3333 23.3332L21.4833 23.5165L16.6667 28.3332ZM18.3333 6.6665C20.1014 6.6665 21.7971 7.36888 23.0474 8.61913C24.2976 9.86937 25 11.5651 25 13.3332C25 15.1013 24.2976 16.797 23.0474 18.0472C21.7971 19.2975 20.1014 19.9998 18.3333 19.9998C16.5652 19.9998 14.8695 19.2975 13.6193 18.0472C12.369 16.797 11.6667 15.1013 11.6667 13.3332C11.6667 11.5651 12.369 9.86937 13.6193 8.61913C14.8695 7.36888 16.5652 6.6665 18.3333 6.6665Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmittedPatientsIcon);
export default __webpack_public_path__ + "static/media/AdmittedPatientsIcon.c94c7d5e.svg";
export { ForwardRef as ReactComponent };